import ClassListSection from "./components/class-list-section";

export default function ClassManagement() {
  return (
    <div className="h-full flex flex-col gap-6">
      <div className="h-full">
        <ClassListSection />
      </div>
    </div>
  );
}
